import api from './api';

const financeService = {
  // Entradas
  getIncomes: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/incomes?${search.toString()}`);
    return data;
  },
  getIncomesTotals: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/incomes/totals?${search.toString()}`);
    return data;
  },
  createIncome: async (payload) => {
    const { data } = await api.post('/finance/incomes', payload);
    return data;
  },
  updateIncome: async (id, payload) => {
    const { data } = await api.put(`/finance/incomes/${id}`, payload);
    return data;
  },
  deleteIncome: async (id) => {
    const { data } = await api.delete(`/finance/incomes/${id}`);
    return data;
  },

  // Entradas Previstas
  deleteExpectedIncome: async (id) => {
    const { data } = await api.delete(`/finance/expected-incomes/${id}`);
    return data;
  },

  // Saídas
  getExpenses: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/expenses?${search.toString()}`);
    return data;
  },
  createExpense: async (payload) => {
    const { data } = await api.post('/finance/expenses', payload);
    return data;
  },
  updateExpense: async (id, payload) => {
    const { data } = await api.put(`/finance/expenses/${id}`, payload);
    return data;
  },
  deleteExpense: async (id) => {
    const { data } = await api.delete(`/finance/expenses/${id}`);
    return data;
  },
  getExpensesAnalysis: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/expenses/analysis?${search.toString()}`);
    return data;
  },
  getExpensesTotals: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/expenses/totals?${search.toString()}`);
    return data;
  },

  // Auxiliares
  getPaymentMethods: async () => (await api.get('/finance/payment-methods')).data,
  getAccounts: async () => (await api.get('/finance/accounts')).data,
  getExpenseCategories: async () => (await api.get('/finance/expense-categories')).data,
  getCashboxCategories: async () => (await api.get('/finance/cashbox-categories')).data,
  getExpenseSubcategories: async (category_id) => (await api.get(`/finance/expense-subcategories${category_id ? `?category_id=${category_id}` : ''}`)).data,
  createExpenseCategory: async ({ name, type }) => (await api.post('/finance/expense-categories', { name, type })).data,
  updateExpenseCategory: async (id, { name, type }) => (await api.put(`/finance/expense-categories/${id}`, { name, type })).data,
  deleteExpenseCategory: async (id) => (await api.delete(`/finance/expense-categories/${id}`)).data,
  createExpenseSubcategories: async ({ category_id, name }) => (await api.post('/finance/expense-subcategories', { category_id, name })).data,

  // Dashboard
  getStats: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/stats?${search.toString()}`);
    return data;
  },

  // Forecast
  getForecast: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/forecast?${search.toString()}`);
    return data;
  },
  getForecastedExpenses: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/forecasted-expenses?${search.toString()}`);
    return data;
  },
  getForecastedIncomes: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/forecasted-incomes?${search.toString()}`);
    return data;
  },
  receiveForecastedIncome: async (id, payload) => {
    const { data } = await api.post(`/finance/forecasted-incomes/${id}/receive`, payload);
    return data;
  },

  // Payroll
  getPayroll: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/payroll?${search.toString()}`);
    return data;
  },
  getPayrollAnalysis: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/payroll/analysis?${search.toString()}`);
    return data;
  },
  exportPayrollAnalysisExcel: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const response = await api.get(`/finance/payroll/analysis/export-excel?${search.toString()}`, {
      responseType: 'blob'
    });
    return response;
  },
  getPayrollYearComparison: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/payroll/year-comparison?${search.toString()}`);
    return data;
  },
  getPayrollOldestYear: async () => {
    const { data } = await api.get('/finance/payroll/oldest-year');
    return data;
  },
  getPayrollForecast: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const { data } = await api.get(`/finance/payroll/forecast?${search.toString()}`);
    return data;
  },
  createPayroll: async (payload) => (await api.post('/finance/payroll', payload)).data,
  updatePayroll: async (id, payload) => (await api.put(`/finance/payroll/${id}`, payload)).data,
  deletePayroll: async (id) => (await api.delete(`/finance/payroll/${id}`)).data,

  // Parties
  getParties: async (params = {}) => {
    const search = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') search.append(k, v);
    });
    const token = localStorage.getItem('accessToken');
    const { data } = await api.get(`/finance/parties?${search.toString()}`, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined);
    return data;
  },
  createParty: async (payload) => (await api.post('/finance/parties', payload)).data,

  // Payroll Indicators
  getPayrollIndicators: async () => (await api.get('/finance/payroll/indicators')).data,
  getPayrollIndicator: async (key) => (await api.get(`/finance/payroll/indicators/${key}`)).data,
  updatePayrollIndicator: async (id, payload) => (await api.put(`/finance/payroll/indicators/${id}`, payload)).data,
  createPayrollIndicator: async (payload) => (await api.post('/finance/payroll/indicators', payload)).data,
};

export default financeService;

